import React from 'react';

import './black-friday-hero-background.css';

export const BlackFridayHeroBackground = () => (
  <div className="black-friday-hero-bg">
    <div className="black-friday-hero-bg--gradient">
      <div className="black-friday-hero-bg--gradient--blue"></div>
      <div className="black-friday-hero-bg--gradient--purple"></div>
    </div>
  </div>
);
